import React from 'react'
import Hero from './components/Hero'
import Services from './components/Services'
import Calltoaction from './components/calltoaction'
import Contact from './components/contactus'
import Footer from './components/footer'
function Home(){
	return(
		   <>
		   <Hero/>
		   <Services/>
		   <Calltoaction title="Call +91 990 292 8259"/>
		   <Contact/>
		   <Footer/>
		   </>
		   
 )
	}
export default Home